import { render, staticRenderFns } from "./CurriculumDetailsAli2271.vue?vue&type=template&id=7fc5878d&scoped=true"
import script from "./CurriculumDetailsAli2271.vue?vue&type=script&lang=js"
export * from "./CurriculumDetailsAli2271.vue?vue&type=script&lang=js"
import style0 from "./CurriculumDetailsAli2271.vue?vue&type=style&index=0&id=7fc5878d&prod&scoped=true&lang=css"
import style1 from "./CurriculumDetailsAli2271.vue?vue&type=style&index=1&id=7fc5878d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc5878d",
  null
  
)

export default component.exports